export { filter, check, propType } from './utilities';
import { graphql } from './graphql';
export default graphql;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/graphql-anywhere/lib/index.js
// module id = 821
// module chunks = 0